import { useMilestones } from "@/hooks/use-mock-data";
import { CheckCircle, AlertTriangle, Clock, Circle } from "lucide-react";

const statusConfig: Record<string, { icon: typeof CheckCircle; color: string }> = {
  achieved: { icon: CheckCircle, color: "#44F2D2" },
  in_progress: { icon: Clock, color: "#4B75F2" },
  at_risk: { icon: AlertTriangle, color: "#EBF216" },
  not_started: { icon: Circle, color: "#555" },
};

export function MilestonesSummary() {
  const { data: milestones } = useMilestones();
  const top3 = milestones
    .filter((m) => m.status !== "achieved")
    .slice(0, 3);

  return (
    <div className="space-y-3">
      {top3.map((ms) => {
        const pct = Math.min(
          (ms.currentValue / ms.targetValue) * 100,
          100
        );
        const config = statusConfig[ms.status] ?? { icon: Circle, color: "#555" };
        const StatusIcon = config.icon;

        return (
          <div key={ms.id}>
            <div className="flex items-center gap-2 mb-1">
              <StatusIcon
                className="w-3.5 h-3.5 shrink-0"
                style={{ color: config.color }}
              />
              <span className="text-[13px] font-medium text-foreground truncate">
                {ms.title}
              </span>
              <span className="ml-auto font-mono text-[11px] text-[#5A6A68] shrink-0">
                {pct.toFixed(0)}%
              </span>
            </div>
            <div className="h-1.5 bg-[rgba(255,255,255,0.06)] rounded-full overflow-hidden ml-5">
              <div
                className="h-full rounded-full animate-progress-sweep"
                style={{
                  width: `${pct}%`,
                  backgroundColor: config.color,
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
}
